import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { baseUrl,openBaseUrl } from 'app/app.config';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { AngularFireAuth } from '@angular/fire/compat/auth';


@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(
    private http: HttpClient,
    private authFire: AngularFireAuth
  ) {}
    
    sendNotifictoken(token,user){
      const formData = {
        token: token,
      };
      const httpOptions = {
        headers: new HttpHeaders({  Authorization: user.auth_token }),
        body:{token: token }        
      }
      return this.http.post<any>(`${baseUrl}/apis/bidding/customers/token?url=${openBaseUrl}`,formData);
    }
    deleteNotifToken(user):Observable<any>{
      const httpOptions = {
        headers: new HttpHeaders({  Authorization: user.auth_token }),
        body:{token: localStorage.getItem('notiToken') }        
      }
      return this.http.delete<any>(`${baseUrl}/apis/bidding/customers/token?url=${openBaseUrl}`,httpOptions);   
     
    }
    getFirebaseUsers():Observable<any>{
      return this.http.get<any>(`${baseUrl}/apis/admin/misc/firebase-users-list`);   
    }

    loadUser(): Observable<any> {
      const data = AuthUtils.getLocalStorage();
      return this.http.get(`${baseUrl}/apis/bidding/user/me-v2`);
    }

    loadUrls(): Observable<any> {
      return this.http.post(`${baseUrl}/apis/admin/settings/`, {});
    }

    firebaseAuthentication(user): void {
      this.getFirebaseUsers().subscribe((result) => {          
             user.firebase_username = result[0].username;
             user.firebase_password = result[0].password;
      this.authFire.signInWithEmailAndPassword(user.firebase_username, user.firebase_password)
      .then((result) => {
        console.log(result, 'firebase admin login success');
        // result.user.tenantId should be ‘TENANT_PROJECT_ID’.
      }).catch((error)=> {
        console.log(error, 'result error');
      });
    }, (error) => {
      console.log(error, 'Firebase Userlisting error');
    }
    );
    }
}

